import React from 'react';
import { Card } from 'react-bootstrap';
import {useFragment} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import AdvanceTableWrapper from "../../components/common/advance-table/AdvanceTableWrapper";
import IndexTableHeader from "../../components/common/headers/IndexTableHeader";
import AdvanceTable from "../../components/common/advance-table/AdvanceTable";
import AdvanceTableFooter from "../../components/common/advance-table/AdvanceTableFooter";
import {LinkCell} from "../../components/common/advance-table/CustomCells";

const columns = [
    {
        accessor: 'name',
        Header: 'Name',
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const { name, id } = rowData.row.original;
            return <LinkCell to={"/networks/" + id} name={name} hasAvatar />
        }
    },
    {
        accessor: 'networkOwner.name',
        Header: 'Network Owner',
        cellProps: {
            className: 'py-2'
        },
        Cell: rowData => {
            const { networkOwner } = rowData.row.original;
            return <LinkCell to={"/network-owners/" + networkOwner.id} name={networkOwner.name} />
        }
    }
];

const NetworksTable = ({networks}) => {
    const nets = useFragment(graphql`
    fragment NetworksTable_Networks on Network @relay(plural: true) {
        id,
        name
        networkOwner {
            id
            name
        }
    }`, networks)
    return (
        <AdvanceTableWrapper
            columns={columns}
            data={nets}
            sortable
            pagination
            perPage={25}
        >
            <Card className="mb-3">
                <Card.Header>
                    <IndexTableHeader name={"Networks"} onNewClick={() => {}} showNew={false} table />
                </Card.Header>
                <Card.Body className="p-0">
                    <AdvanceTable
                        table
                        headerClassName="bg-200 text-900 text-nowrap align-middle"
                        rowClassName="align-middle white-space-nowrap"
                        tableProps={{
                            size: 'sm',
                            striped: true,
                            className: 'fs--1 mb-0 overflow-hidden'
                        }}
                    />
                </Card.Body>
                <Card.Footer>
                    <AdvanceTableFooter rowCount={nets.length}
                                        table
                                        rowInfo
                                        navButtons
                                        rowsPerPageSelection
                    />
                </Card.Footer>
            </Card>
        </AdvanceTableWrapper>
    )
}
export default NetworksTable